import React, { type FC } from "react";

export const CustomTooltipLayout: FC<React.PropsWithChildren> = (props) => {
	const preventEvent = (e: React.MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();
	};

	return <div data-testid="custom-tooltip-layout" onClick={preventEvent} {...props} />;
};
